module.exports = __webpack_public_path__ + "product/product-step-plain@2x-0947b26d3555aeb013c2ac6f910362af.webp";